import { render } from "./UpdateInfoDialog.vue?vue&type=template&id=6a431959"
import script from "./UpdateInfoDialog.vue?vue&type=script&lang=js"
export * from "./UpdateInfoDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__